import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 28 28',
    defaultAriaLabel: 'File Download Icon',
};

export const FileDownloadIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path d="M21.3105 11.2871L15.0117 17.5859L15.0117 2C15.0117 1.44772 14.564 1 14.0117 1C13.4594 1 13.0117 1.44772 13.0117 2L13.0117 17.5857L6.71311 11.2871C6.32259 10.8966 5.68942 10.8966 5.2989 11.2871C4.90837 11.6776 4.90837 12.3108 5.29889 12.7013L13.3047 20.7072C13.4923 20.8947 13.7466 21.0001 14.0118 21.0001C14.277 21.0001 14.5314 20.8947 14.7189 20.7072L22.7247 12.7013C23.1152 12.3108 23.1152 11.6776 22.7247 11.2871C22.3342 10.8966 21.701 10.8966 21.3105 11.2871Z" />
            <path d="M27 22.0078C27 21.4555 26.5523 21.0078 26 21.0078C25.4477 21.0078 25 21.4555 25 22.0078V25H3L3 22C3 21.4477 2.55228 21 2 21C1.44772 21 1 21.4477 1 22V25C1 26.1046 1.89543 27 3 27H25C26.1046 27 27 26.1046 27 25V22.0078Z" />
        </SvgIcon>
    );
};
